
{
  "familyId": "SWW-LEEN-ENG-STAM",
  "questions": [
    {
      "id": "SWW-LEEN-ENG-STAM-001",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "multiple_choice",
      "question": "Een klasgenoot zegt: 'De stam van *racen* is *rac*, want in het Nederlands halen we de stille -e altijd weg.' Welke stam is correct en waarom?",
      "context": null,
      "options": [
        "race — bij Engelse leenwoorden behoud je de Engelse spelling",
        "rac — Nederlandse regel: stille -e wordt geschrapt",
        "raac — open lettergreep, dus klinker verdubbelen",
        "races — extra -s om te onderscheiden van het zelfstandig naamwoord"
      ],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "verbTable", "data": { "verb": "racen", "type": "leenwoord-engels", "forms": { "stam": ["race"], "ik": ["race"], "vt": ["racete"], "vd": ["geracet"] }, "label": "Engels leenwerkwoord: racen → stam = race" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden — Regel", "content": "Bij Engelse leenwoorden bepaal je de stam met werkwoord min -en, maar de Engelse spelling blijft intact. Nederlandse spellingregels (klinker verdubbelen, stille -e schrappen) gelden HIER NIET.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_stem",
      "variantIndex": 1,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Regel (Engelse leenwoorden): werkwoord min -en = stam, Engelse spelling blijft behouden. Stap 1: Neem het werkwoord: racen. Stap 2: Haal -en af: racen − en = race. Stap 3: De Engelse spelling 'race' (met -ce) blijft intact — Nederlandse regels (stille -e schrappen, klinker verdubbelen) gelden NIET. Checkstrategie: klinkt de stam nog als het Engelse woord? race ✓. Vergelijk je antwoord altijd met de Engelse uitspraak en spelling om vernederlandsing te vermijden.",
        "solutionSteps": ["Neem het werkwoord: racen", "Haal -en eraf: racen − en = race", "Behoud de Engelse spelling: 'race' (met -ce)", "Check: vergelijk met Engelse uitspraak en spelling — klinkt het nog als 'race'? ✓", "Sluit rac (NL-regel), raac (klinker verdubbeld) en races (extra -s) gemotiveerd uit"],
        "distractorExplanations": {
          "0": "Correct! Engelse leenwoorden: werkwoord − en = race. De Engelse spelling blijft behouden. Nederlandse regels gelden niet.",
          "1": "De Engelse spelling is hier aangepast aan Nederlandse regels. 'Rac' mist de -e. Bij Engelse leenwoorden geldt: Engelse spelling 'race' (met -ce) blijft behouden.",
          "2": "De klinker is hier verdubbeld volgens NL-regel. 'Raac' heeft een dubbele a die niet in het Engelse woord staat. Bij Engelse leenwoorden geldt: Engelse spelling 'race' (met één a) blijft behouden.",
          "3": "Hier is een extra letter toegevoegd. 'Races' heeft een -s die niet bij de stam hoort. De stam-regel is gewoon: werkwoord − en = race."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-stripped", "label": "Engelse -e weggelaten", "optionIndex": 1 },
          { "id": "sww.loanword-vowel-doubled", "label": "Klinker verdubbeld volgens NL-regels", "optionIndex": 2 },
          { "id": "sww.stem-with-extra-letter", "label": "Extra letter aan stam toegevoegd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-002",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "multiple_choice",
      "question": "Een schrijver twijfelt tussen 'Ik chil' en 'Ik chill' in een zin. Welke vorm is correct voor de ik-persoon en waarom?",
      "context": null,
      "options": [
        "Ik chill — de Engelse dubbele -ll blijft behouden in de stam",
        "Ik chil — Nederlandse regel verkort dubbele medeklinker",
        "Ik chille — een -e toevoegen markeert de werkwoordsvorm",
        "Ik chillen — bij ik gebruik je het hele werkwoord"
      ],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "verbTable", "data": { "verb": "chillen", "type": "leenwoord-engels", "forms": { "stam": ["chill"], "ik": ["chill"], "vt": ["chillde"], "vd": ["gechilld"] }, "label": "Engels leenwerkwoord: chillen → stam = chill (dubbele l blijft)" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden — Regel", "content": "Bij 'ik' gebruik je alleen de stam. De stam van 'chillen' is 'chill' (met dubbel l, Engelse spelling).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_first_person",
      "variantIndex": 2,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Regel (Engelse leenwoorden): stam = werkwoord − en, Engelse spelling intact. Stap 1: Neem het werkwoord: chillen. Stap 2: Haal -en af: chillen − en = chill. Stap 3: De Engelse spelling 'chill' (met dubbele l) blijft behouden — de NL-regel om dubbele medeklinkers te verkorten geldt NIET. Stap 4: Bij 'ik' gebruik je alleen de stam: ik chill. Checkstrategie: vergelijk je vorm met de Engelse spelling van het werkwoord — wijkt hij af? Dan is hij waarschijnlijk vernederlandst.",
        "solutionSteps": ["Neem het werkwoord: chillen", "Haal -en eraf: chillen − en = chill (dubbele l behouden)", "Bij 'ik' gebruik je alleen de stam (geen -t)", "Antwoord: ik chill", "Check: vergelijk met Engelse spelling van 'chill' — dubbele l intact? ✓"],
        "distractorExplanations": {
          "0": "Correct! Engelse leenwoorden: chillen − en = chill (dubbele l behouden). Bij 'ik' alleen de stam.",
          "1": "De dubbele medeklinker is hier weggelaten volgens NL-regel. Bij Engelse leenwoorden geldt: Engelse spelling 'chill' (met dubbele l) blijft behouden. NL-verkortingsregel geldt niet.",
          "2": "Hier is een extra -e toegevoegd aan de stam. 'Chille' is geen correcte ik-vorm. De regel zegt: bij 'ik' gebruik je alleen de stam (chill), geen -e.",
          "3": "Hier is het hele werkwoord gebruikt als ik-vorm. 'Chillen' is de infinitief. De regel zegt: bij 'ik' alleen de stam: chill."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.loanword-double-consonant-lost", "label": "Dubbele medeklinker vernederlandst (enkel)", "optionIndex": 1 },
          { "id": "sww.stem-extra-e-added", "label": "Extra -e aan stam toegevoegd", "optionIndex": 2 },
          { "id": "sww.infinitive-instead-of-stem", "label": "Hele werkwoord gebruikt i.p.v. stam", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-003",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "multiple_choice",
      "question": "Bekijk vier voorgestelde stammen voor 'managen'. Welke past binnen de regel 'werkwoord − en, Engelse spelling behouden'?",
      "context": null,
      "options": ["manage", "manag", "manaag", "manager"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "verbTable", "data": { "verb": "managen", "type": "leenwoord-engels", "forms": { "stam": ["manage"], "ik": ["manage"], "vt": ["managede"], "vd": ["gemanaged"] }, "label": "Engels leenwerkwoord: managen → stam = manage" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden — Regel", "content": "Bij Engelse leenwoorden: werkwoord min -en = stam. Behoud de Engelse spelling: managen − en = manage.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_stem_manage",
      "variantIndex": 3,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Regel (Engelse leenwoorden): werkwoord min -en = stam, Engelse spelling intact. Stap 1: Neem het werkwoord: managen. Stap 2: Haal -en af: managen − en = manage. Stap 3: De Engelse spelling 'manage' (met -ge) blijft behouden. Checkstrategie: klinkt de stam nog als het Engelse woord? manage ✓. Vergelijk met alternatieven: 'manag' (vernederlandst), 'manaag' (klinker verdubbeld), 'manager' (zelfstandig naamwoord) — elk schendt een specifieke deelregel.",
        "solutionSteps": ["Neem het werkwoord: managen", "Haal -en eraf: managen − en = manage", "Behoud de Engelse spelling: 'manage' (met -ge)", "Check: klinkt het als het Engelse woord? ✓", "Sluit manag, manaag, manager elk met een specifieke regel uit"],
        "distractorExplanations": {
          "0": "Correct! Engelse leenwoorden: managen − en = manage. De Engelse spelling blijft behouden.",
          "1": "De Engelse spelling is hier aangepast. 'Manag' mist de -e. Bij Engelse leenwoorden geldt: Engelse spelling 'manage' (met -ge) blijft behouden.",
          "2": "De klinker is hier verdubbeld volgens NL-regel. 'Manaag' heeft een dubbele a die niet in het Engelse woord staat. Behoud de Engelse spelling: manage.",
          "3": "Hier is het zelfstandig naamwoord gebruikt. 'Manager' is een persoon, niet de stam van het werkwoord. De stam-regel is: werkwoord − en = manage."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-stripped", "label": "Engelse -e weggelaten", "optionIndex": 1 },
          { "id": "sww.loanword-vowel-doubled", "label": "Klinker verdubbeld volgens NL-regels", "optionIndex": 2 },
          { "id": "sww.noun-instead-of-stem", "label": "Zelfstandig naamwoord i.p.v. werkwoordstam", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-004",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "multiple_choice",
      "question": "Een leerling schrijft 'Hij timed altijd alles precies' en denkt dat dit klopt omdat -ed in het Engels ook gebruikt wordt. Welke vorm is correct in het Nederlands en welke denkfout maakt de leerling?",
      "context": null,
      "options": [
        "timet — Nederlandse hij-vorm krijgt -t, Engelse uitgangen gelden niet",
        "timt — eerst Engelse -e weghalen, dan -t toevoegen",
        "timed — Engelse verleden tijd-uitgang gebruiken",
        "tijmt — Engelse 'i' vernederlandsen naar 'ij'"
      ],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "verbTable", "data": { "verb": "timen", "type": "leenwoord-engels", "forms": { "stam": ["time"], "ik": ["time"], "hij": ["timet"], "vd": ["getimed"] }, "label": "Engels leenwerkwoord: timen → stam = time, hij/zij = timet" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden — Regel", "content": "De stam van 'timen' is 'time' (Engelse spelling). Bij hij/zij: stam + t = time + t = timet.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_third_person",
      "variantIndex": 4,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Regel (Engelse leenwoorden + hij-vorm): stam = werkwoord − en (Engelse spelling intact), bij hij/zij + t. Stap 1: De stam van 'timen' is 'time' — Engelse spelling met -e blijft. Stap 2: Bij hij/zij voeg je -t toe aan de stam: time + t = timet. Stap 3: De Engelse verleden-tijd-uitgang -ed geldt NIET in het Nederlands. Checkstrategie: bepaal eerst de stam zonder NL-regels toe te passen, plak dan de NL-persoonsuitgang -t, en vergelijk: timet ≠ timt (stam vernederlandst), ≠ timed (Engelse grammatica), ≠ tijmt (klinker vernederlandst).",
        "solutionSteps": ["Bepaal de stam: timen → time (Engelse spelling intact, -e blijft)", "Bij hij/zij: stam + t", "time + t = timet", "Check: Engelse spelling behouden ✓, NL-persoonsuitgang gebruikt ✓", "Sluit timt, timed, tijmt elk met een specifieke regel uit"],
        "distractorExplanations": {
          "0": "Correct! Stam 'time' + t = timet. De Engelse spelling blijft behouden, NL-persoonsuitgang -t toegevoegd.",
          "1": "Hier is de stam 'vernederlandst'. 'Timt' mist de -e van de Engelse stam 'time'. Behoud de Engelse spelling: time + t = timet.",
          "2": "Hier is -d gebruikt in plaats van -t. Bij hij/zij voeg je altijd -t toe (niet -d): timet. De Engelse verleden tijd (-ed) hoort hier niet.",
          "3": "Hier is de spelling aangepast aan het Nederlands. 'Tijmt' verandert de 'i' in 'ij', maar de Engelse spelling blijft behouden: time + t = timet."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-stripped", "label": "Engelse -e uit stam weggelaten", "optionIndex": 1 },
          { "id": "sww.loanword-english-grammar", "label": "Engelse -ed verward met NL hij-vorm", "optionIndex": 2 },
          { "id": "sww.loanword-spelling-dutchified", "label": "Engelse spelling vernederlandst (i → ij)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-005",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "fill_in",
      "question": "De stam van 'saven' (een Engels leenwerkwoord) wordt door drie leerlingen verschillend gespeld: 'sav', 'seef', '...'. Welke stam is correct volgens de regel 'werkwoord − en, Engelse spelling behouden'? Typ de juiste stam.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": { "acceptedAnswers": ["save"], "caseSensitive": false, "placeholder": "..." },
      "stimulusAids": [{ "type": "verbTable", "data": { "verb": "saven", "type": "leenwoord-engels", "forms": { "stam": ["save"], "ik": ["save"], "vt": ["savede"], "vd": ["gesaved"] }, "label": "Engels leenwerkwoord: saven → stam = save" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden — Regel", "content": "Bij Engelse leenwoorden: werkwoord min -en = stam. Behoud de Engelse spelling: saven − en = save.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_stem_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Regel (Engelse leenwoorden): werkwoord min -en = stam, Engelse spelling intact. Neem het werkwoord 'saven' en haal -en eraf: saven − en = save. De Engelse spelling 'save' (met -ve) blijft behouden. Checkstrategie: spreek je antwoord hardop uit en vergelijk met de Engelse uitspraak — wijken ze af? Dan is je antwoord waarschijnlijk vernederlandst. 'Sav' (zonder -e) en 'seef' (vernederlandst) schenden beide de Engelse-spelling-regel.",
        "solutionSteps": ["Neem het werkwoord: saven", "Haal -en eraf: saven − en = save", "Behoud de Engelse spelling: 'save' (met -ve)", "Check: vergelijk met Engelse uitspraak/spelling — blijft de stam intact?"]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-stripped", "label": "Mogelijke fout: 'sav' (Engelse -e weggelaten)" },
          { "id": "sww.loanword-spelling-dutchified", "label": "Mogelijke fout: 'seef' (vernederlandst)" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-006",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "matching",
      "question": "Koppel elk Engels leenwerkwoord aan de correcte stam (let op: in elke stam moet de Engelse spelling behouden blijven — geen Nederlandse aanpassingen).",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "racen", "right": "race" },
          { "left": "managen", "right": "manage" },
          { "left": "chillen", "right": "chill" },
          { "left": "timen", "right": "time" },
          { "left": "saven", "right": "save" }
        ]
      },
      "stimulusAids": [{ "type": "verbTable", "data": { "verb": "diverse", "type": "leenwoord-engels", "forms": { "stam": ["race", "manage", "chill", "time", "save"] }, "label": "Engelse leenwerkwoorden — stammenoverzicht" } }],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stam = werkwoord − en",
            "content": "Bij Engelse leenwoorden: werkwoord min -en = stam. Behoud altijd de Engelse spelling (geen Nederlandse aanpassingen aan klinkers of medeklinkers).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "english_loanword_stem_matching",
      "variantIndex": 6,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Regel (Engelse leenwoorden): werkwoord − en = stam, Engelse spelling intact. Voor elk werkwoord: haal -en eraf, behoud de Engelse spelling. racen → race (NL-regel 'stille -e schrappen' geldt niet); managen → manage (-ge intact); chillen → chill (dubbele l blijft!); timen → time (-e blijft); saven → save (-ve blijft). De Engelse spelling met -e, -ll, etc. blijft intact — NL-spellingregels gelden NIET. Checkstrategie: vergelijk elke gekoppelde stam met de Engelse spelling van het werkwoord en sluit elke vernederlandsing uit.",
        "solutionSteps": [
          "Voor elke koppel: werkwoord − en = stam",
          "Behoud Engelse spelling (geen NL-aanpassingen)",
          "Let op dubbele medeklinkers (chill, niet chil)",
          "Let op stille -e (race, time, save, manage — blijft staan)",
          "Check elke koppeling tegen de Engelse spelling van het werkwoord"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-stripped", "label": "Engelse spelling versimpeld" },
          { "id": "sww.loanword-double-consonant-lost", "label": "Dubbele medeklinker vernederlandst" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-007",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "error_spotting",
      "question": "Vind de fouten in de Engelse leenwoorden (Engelse spelling moet behouden blijven).",
      "context": null,
      "correctAnswer": 0,
      "data": {
        "text": "Ik chil graag in het weekend. Ik sav het document altijd snel op de computer.",
        "errors": [
          { "word": "chil", "position": 1, "correction": "chill", "explanation": "De Engelse dubbele -ll blijft behouden in de stam: chill (niet chil). Nederlandse regels gelden hier niet." },
          { "word": "sav", "position": 7, "correction": "save", "explanation": "De Engelse -e blijft behouden in de stam: save (niet sav). Werkwoord min -en geeft save." }
        ]
      },
      "stimulusAids": [{ "type": "verbTable", "data": { "verb": "chillen/saven", "type": "leenwoord-engels", "forms": { "stam": ["chill", "save"], "ik": ["chill", "save"] }, "label": "Correcte stammen: chill (dubbele l), save (-e intact)" } }],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Twee vuistregels", "content": "1) Werkwoord min -en = stam. 2) Engelse spelling blijft intact (geen NL-aanpassingen aan klinkers, medeklinkers of -e).", "icon": "lightbulb" } }
      ],
      "conceptId": "english_loanword_stem_error_spotting",
      "variantIndex": 7,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Twee fouten waar de Engelse spelling is versimpeld — beide via dezelfde analyse. Regel: werkwoord − en = stam én Engelse spelling intact. 'Chil' moet 'chill' zijn (de Engelse dubbele -ll blijft). 'Sav' moet 'save' zijn (de Engelse -e blijft). Bij Engelse leenwoorden gelden de Nederlandse spellingregels (medeklinker enkelen, stille -e schrappen) NIET. Checkstrategie: vergelijk elke werkwoordsvorm met de Engelse stam-spelling van het bijbehorende werkwoord — wijkt hij af? Dan is hij vernederlandst en dus fout.",
        "solutionSteps": [
          "Bepaal de stam: werkwoord min -en",
          "Behoud de Engelse spelling exact",
          "Geen NL-aanpassingen aan klinkers, medeklinkers of -e",
          "Vergelijk geschreven vorm met de Engelse stam",
          "Spot waar NL-regels zijn toegepast en corrigeer terug naar Engels"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-stripped", "label": "Engelse -e weggehaald uit stam" },
          { "id": "sww.loanword-double-consonant-lost", "label": "Engelse dubbele medeklinker enkel gemaakt" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-008",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "categorize",
      "question": "Sorteer elke stamvorm: behoudt deze de Engelse spelling, of is hij vernederlandst?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Correct (Engelse spelling)", "Fout (vernederlandst)"],
        "items": [
          { "text": "race (van racen)", "correctCategory": 0 },
          { "text": "chill (van chillen)", "correctCategory": 0 },
          { "text": "manage (van managen)", "correctCategory": 0 },
          { "text": "save (van saven)", "correctCategory": 0 },
          { "text": "rac (van racen)", "correctCategory": 1 },
          { "text": "chil (van chillen)", "correctCategory": 1 },
          { "text": "manaag (van managen)", "correctCategory": 1 },
          { "text": "seef (van saven)", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [{ "type": "verbTable", "data": { "verb": "diverse", "type": "leenwoord-engels", "forms": { "correct": ["race", "chill", "manage", "save"], "fout": ["rac", "chil", "manaag", "seef"] }, "label": "Engelse leenwerkwoorden: correcte vs. vernederlandste stammen" } }],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Engelse spelling behouden",
            "content": "Correcte stam: werkwoord − en, met Engelse spelling intact. Fout: klinker verdubbeld, dubbele medeklinker geënkeld, of -e weggelaten.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "english_loanword_stem_categorize",
      "variantIndex": 8,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Regel (Engelse leenwoorden): Engelse spelling behouden = correct; toepassen van NL-spellingregels = vernederlandst = fout. Correct: race, chill, manage, save (allemaal werkwoord − en met intacte Engelse spelling). Fout: rac (-e weggelaten), chil (dubbele l verkort), manaag (a verdubbeld), seef (vernederlandst). Checkstrategie: vergelijk elke stamvorm met de Engelse spelling van het bijbehorende werkwoord — identiek aan werkwoord − en (Engels) = correct; afwijkend = vernederlandst.",
        "solutionSteps": [
          "Lees de stamvorm",
          "Bepaal de verwachte Engelse stam: werkwoord − en, Engelse spelling intact",
          "Vergelijk: identiek? → correct. Aangepast? → vernederlandst",
          "Benoem welke NL-regel verkeerd is toegepast (klinker-verdubbeling, medeklinker-enkeling, -e schrappen)"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-dutchified", "label": "Engelse spelling vernederlandst" },
          { "id": "sww.loanword-vowel-doubled", "label": "Klinker verdubbeld volgens NL-regel" }
        ]
      }
    }
  ]
}
